import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppStore } from '@core/store/core/app.store';

import { finalize } from 'rxjs';

let activeRequests = 0;

export const httpLoaderInterceptor: HttpInterceptorFn = (req, next) => {
  const appStore = inject(AppStore);

  activeRequests++;
  if (activeRequests === 1) {
    appStore.startLoading();
  }

  return next(req).pipe(
    finalize(() => {
      activeRequests--;
      if (activeRequests === 0) {
        appStore.stopLoading();
      }
    })
  );
};
